export const CURRENCY_CONFIG: {
  [key: string]: { symbol: string; icon?: string; name: string; flag?: string };
} = {
  AZN: {
    symbol: '₼',
    icon: 'assets/azn-symbol.svg',
    name: 'Azerbaijan Manat',
    flag: 'assets/aze-flag.svg',
  },
  USD: {
    symbol: '$',
    icon: 'assets/usd-symbol.svg',
    name: 'US Dollar',
    flag: 'assets/us-flag.svg',
  },
  EUR: {
    symbol: '€',
    icon: 'assets/euro-symbol.svg',
    name: 'Euro',
    flag: 'assets/eu-flag.svg',
  },
  GBP: { symbol: '£', icon: 'assets/gbp-symbol.svg', name: 'British Pound' },
  RUB: {
    symbol: '₽',
    icon: 'assets/rub-symbol.svg',
    name: 'Russian Ruble',
    flag: 'assets/ru-flag.svg',
  },
  TRY: { symbol: '₺', icon: 'assets/try-symbol.svg', name: 'Turkish Lira' },
  BYN: {
    symbol: 'Br',
    icon: 'assets/byn-symbol.svg',
    name: 'Belarusian Ruble',
  },
  KZT: {
    symbol: '₸',
    icon: 'assets/kzt-symbol.svg',
    name: 'Kazakhstani Tenge',
  },
  CNY: { symbol: '¥', icon: 'assets/cny-symbol.svg', name: 'Chinese Yuan' },
  JPY: { symbol: '¥', icon: 'assets/jpy-symbol.svg', name: 'Japanese Yen' },
  CAD: { symbol: 'C$', icon: 'assets/cad-symbol.svg', name: 'Canadian Dollar' },
  CHF: { symbol: 'CHF', icon: 'assets/chf-symbol.svg', name: 'Swiss Franc' },
  INR: { symbol: '₹', icon: 'assets/inr-symbol.svg', name: 'Indian Rupee' },
  BRL: { symbol: 'R$', icon: 'assets/brl-symbol.svg', name: 'Brazilian Real' },
  MXN: { symbol: '$', icon: 'assets/mxn-symbol.svg', name: 'Mexican Peso' },
  SEK: { symbol: 'kr', icon: 'assets/sek-symbol.svg', name: 'Swedish Krona' },
  NOK: { symbol: 'kr', icon: 'assets/nok-symbol.svg', name: 'Norwegian Krone' },
  DKK: { symbol: 'kr', icon: 'assets/dkk-symbol.svg', name: 'Danish Krone' },
  PLN: { symbol: 'zł', icon: 'assets/pln-symbol.svg', name: 'Polish Zloty' },
  CZK: { symbol: 'Kč', icon: 'assets/czk-symbol.svg', name: 'Czech Koruna' },
  HUF: {
    symbol: 'Ft',
    icon: 'assets/huf-symbol.svg',
    name: 'Hungarian Forint',
  },
  RON: { symbol: 'lei', icon: 'assets/ron-symbol.svg', name: 'Romanian Leu' },
  BGN: { symbol: 'лв', icon: 'assets/bgn-symbol.svg', name: 'Bulgarian Lev' },
  UAH: {
    symbol: '₴',
    icon: 'assets/uah-symbol.svg',
    name: 'Ukrainian Hryvnia',
  },
  GEL: { symbol: '₾', icon: 'assets/gel-symbol.svg', name: 'Georgian Lari' },
  AMD: { symbol: '֏', icon: 'assets/amd-symbol.svg', name: 'Armenian Dram' },
  KGS: { symbol: 'с', icon: 'assets/kgs-symbol.svg', name: 'Kyrgyzstani Som' },
  UZS: {
    symbol: 'soʻm',
    icon: 'assets/uzs-symbol.svg',
    name: 'Uzbekistani Som',
  },
  TMT: {
    symbol: 'm',
    icon: 'assets/tmt-symbol.svg',
    name: 'Turkmenistani Manat',
  },
  TJS: {
    symbol: 'SM',
    icon: 'assets/tjs-symbol.svg',
    name: 'Tajikistani Somoni',
  },
  MDL: { symbol: 'lei', icon: 'assets/mdl-symbol.svg', name: 'Moldovan Leu' },
  ZAR: {
    symbol: 'R',
    icon: 'assets/zar-symbol.svg',
    name: 'South African Rand',
  },
  NGN: { symbol: '₦', icon: 'assets/ngn-symbol.svg', name: 'Nigerian Naira' },
  KES: {
    symbol: 'KSh',
    icon: 'assets/kes-symbol.svg',
    name: 'Kenyan Shilling',
  },
  GHS: { symbol: '₵', icon: 'assets/ghs-symbol.svg', name: 'Ghanaian Cedi' },
  EGP: { symbol: '£', icon: 'assets/egp-symbol.svg', name: 'Egyptian Pound' },
  MAD: { symbol: 'DH', icon: 'assets/mad-symbol.svg', name: 'Moroccan Dirham' },
  TND: { symbol: 'د.ت', icon: 'assets/tnd-symbol.svg', name: 'Tunisian Dinar' },
  AED: { symbol: 'د.إ', icon: 'assets/aed-symbol.svg', name: 'UAE Dirham' },
  SAR: { symbol: '﷼', icon: 'assets/sar-symbol.svg', name: 'Saudi Riyal' },
  QAR: { symbol: '﷼', icon: 'assets/qar-symbol.svg', name: 'Qatari Riyal' },
  KWD: { symbol: 'د.ك', icon: 'assets/kwd-symbol.svg', name: 'Kuwaiti Dinar' },
  BHD: {
    symbol: '.د.ب',
    icon: 'assets/bhd-symbol.svg',
    name: 'Bahraini Dinar',
  },
  OMR: { symbol: '﷼', icon: 'assets/omr-symbol.svg', name: 'Omani Rial' },
  JOD: {
    symbol: 'د.ا',
    icon: 'assets/jod-symbol.svg',
    name: 'Jordanian Dinar',
  },
  LBP: { symbol: '£', icon: 'assets/lbp-symbol.svg', name: 'Lebanese Pound' },
  SYP: { symbol: '£', icon: 'assets/syp-symbol.svg', name: 'Syrian Pound' },
  IQD: { symbol: 'ع.د', icon: 'assets/iqd-symbol.svg', name: 'Iraqi Dinar' },
  IRR: { symbol: '﷼', icon: 'assets/irr-symbol.svg', name: 'Iranian Rial' },
  AFN: { symbol: '؋', icon: 'assets/afn-symbol.svg', name: 'Afghan Afghani' },
  PKR: { symbol: '₨', icon: 'assets/pkr-symbol.svg', name: 'Pakistani Rupee' },
  BDT: { symbol: '৳', icon: 'assets/bdt-symbol.svg', name: 'Bangladeshi Taka' },
  LKR: { symbol: '₨', icon: 'assets/lkr-symbol.svg', name: 'Sri Lankan Rupee' },
  NPR: { symbol: '₨', icon: 'assets/npr-symbol.svg', name: 'Nepalese Rupee' },
  BTN: {
    symbol: 'Nu.',
    icon: 'assets/btn-symbol.svg',
    name: 'Bhutanese Ngultrum',
  },
  MVR: {
    symbol: 'Rf',
    icon: 'assets/mvr-symbol.svg',
    name: 'Maldivian Rufiyaa',
  },
};
